import { ApiClient } from './client';
import * as qs from 'qs';

import { GreetingModel } from '../../../../types/app';
import { SERVER_ENDPOINT } from '../utils/constants';

class StrapiApi {
  constructor(private readonly client: ApiClient) {
  }

  // TODO: Greeting[] type
  async getAllGreetings() {
    return await this.client.get('/greetings');
  }

  async getGreetingById(id: string): Promise<GreetingModel> {
    const query = qs.stringify({
      populate: [
        'logo',
        'country',
        'persons',
        'persons.logo',
        'persons.country',
      ],
    }, {
      encodeValuesOnly: true,
      encoder: (str) => str,
    });
    return await this.client.get(`/greetings/${id}?${query}`);
  }

  getBadgeLoginUrl() {
    return `${SERVER_ENDPOINT}/badge/pingfed`;
  }

  async badgeLogout() {
    return await this.client.post(`/badge/logout`);
  }

  async requestNameToBeShown() {
    return await this.client.get(`/badge/show-name`);
  }
}

export const api = new StrapiApi(new ApiClient(`${SERVER_ENDPOINT}/api`));
